import { useAuth } from "@/_core/hooks/useAuth";
import type { ReactNode } from "react";
import { Redirect } from "wouter";

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { loading, user } = useAuth();

  if (loading) return null;
  if (user?.role !== "admin") return <Redirect to="/projects" replace />;

  return children;
}
